import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const GeneRiskAbout = () => {
  return (
    <AboutTemplate 
      {...platformData.generisk}
      platformKey="generisk"
    />
  );
};

export default GeneRiskAbout; 